/**
 * Hostnames that count as local development.
 *
 * This is deliberately broader than `localhost`: the app is served from
 * `app.lvh.me:5000` in development (`lvh.me` is public DNS resolving `*.lvh.me`
 * to `127.0.0.1`, which is how the dev setup gets a real subdomain without
 * /etc/hosts edits — see components/19-deployment-and-infrastructure.md). A bare
 * `localhost` equality check therefore disabled `window.dev` outright in the
 * only environment it was ever meant to run in.
 *
 * Production hosts (`app.encouple.com`, `encouple.com`) match none of these.
 *
 * @param {string} [hostname] - Defaults to the current location's hostname.
 * @returns {boolean}
 */
export function isDevHost(hostname = window.location.hostname) {
  if (!hostname) return false;
  // Strip IPv6 brackets so '[::1]' and '::1' both resolve the same way.
  const host = hostname.replace(/^\[|\]$/g, '').toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1' || host === '::1') return true;
  // lvh.me and any subdomain of it (app.lvh.me, marketing.lvh.me, …).
  return host === 'lvh.me' || host.endsWith('.lvh.me');
}
